import { ComponentType } from 'react';

import { SubdivisionInput } from '@gasbi/shared/common/features/subdivisions/types';
import { useFormik } from 'formik';

export enum CreateSubdivisionFormSteps {
  GeneralInfo = 1,
  ContactInfo = 2,
  Address = 3,
}

export type CreateSubdivisionFormValues = SubdivisionInput;

export type CreateSubdivisionStepProps = {
  formik: ReturnType<typeof useFormik>;
  /** The step opened from the підрозділ's «Дії» rather than the create form. */
  isEditMode?: boolean;
};

export type CreateSubdivisionStepComponents = Partial<
  Record<CreateSubdivisionFormSteps, ComponentType<CreateSubdivisionStepProps>>
>;
